module.exports = __webpack_public_path__ + "img/whatsapp-instruction-4.57b84636.png";